// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"325e2d2b","38":"ce7a8b95","453":"a9770b22","606":"4f66c262"}[chunkId] + ".chunk.js";
};